import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class ReleaseIcon extends Field {
  static attributesForModel() {
    return ['releaseId'];
  }

  get title() {
    return `${terminology('Release')} icon`;
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: 'fa-regular fa-calendar-lines' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.releaseId) {
      return { icon: { name: 'fa-regular fa-calendar-lines' } };
    }

    return {};
  }
}
